import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { BookingSuccessModal } from "./component";
import {
  getConfirmationDetails,
  getConfirmationDetailsCallState,
  getEarnedString,
  getConfirmationEmail,
  getUserSelectedTravelersList,
  getOfferToApply,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import { actions } from "../../actions";
import { getHotelShopSelectedLodging } from "../../../shop/reducer/selectors";
import {
  getHasUserSetHotelPreferences,
  getUserHotelPreferencesCallState,
} from "../../../availability/reducer";
import {
  getRewardsAccountWithLargestEarnForBanner,
  getSelectedAccountReferenceId,
  getRewardsAccounts,
} from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  reservation: getConfirmationDetails(state),
  confirmationDetailsCallState: getConfirmationDetailsCallState(state),
  selectedLodging: getHotelShopSelectedLodging(state),
  earnString: getEarnedString(state),
  confirmationEmail: getConfirmationEmail(state),
  hasUserSetHotelPreferences: getHasUserSetHotelPreferences(state),
  userHotelPreferencesCallState: getUserHotelPreferencesCallState(state),
  selectedTravelersList: getUserSelectedTravelersList(state),
  selectedAccountReferenceId: getSelectedAccountReferenceId(state),
  rewardsAccounts: getRewardsAccounts(state),
  largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
  offerToApply: getOfferToApply(state),
});

const mapDispatchToProps = {
  resetBookState: actions.resetBook,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type BookingSuccessModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedBookingSuccessModal = withRouter(
  connector(BookingSuccessModal)
);
